import React, { useCallback, useEffect, useState } from "react";
import { createPortal } from "react-dom";
import { copyToClipboard } from "./payoutsFormat.js";
import { BottomToast } from "./styles.payouts.js";

const TOAST_MS = 2000;

// Copies text and shows a "Copied" toast at the bottom of the screen; `showToast(message)`
// shows any other short message the same way. Render `copyToast` once in the screen.
const useCopyToast = (message = "Copied") => {
  const [toast, setToast] = useState(null);

  // showing again while one is up restarts the timer
  useEffect(() => {
    if (!toast) return undefined;
    const timer = setTimeout(() => setToast(null), TOAST_MS);
    return () => clearTimeout(timer);
  }, [toast]);

  const showToast = useCallback(
    (text) => setToast({ id: Date.now(), text }),
    []
  );

  const copy = useCallback(
    async (text) => {
      if (await copyToClipboard(text)) showToast(message);
    },
    [message, showToast]
  );

  // portaled to body so no parent (the sheet overlay, scroll areas) can cover or clip it
  const copyToast = toast
    ? createPortal(<BottomToast role="status">{toast.text}</BottomToast>, document.body)
    : null;

  return { copy, copyToast, showToast };
};

export default useCopyToast;
